import { Button, Card, CardActions, CardContent, Divider, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ImagePreview from './ImagePreview';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


function CamPopupModel({ open, onClose, FisNo, DosyaTipi, DosyaTipiText, className, issondaj = 0, ...rest }) {
  const classes = useStyles();
  const [dataUriUrl, setDataUri] = useState("");
  const [openCam, setOpenCam] = useState(false);
  function handleTakePhotoAnimationDone(dataUri) {
    setDataUri(dataUri);
    setOpenCam(true);
  }
  function onClosePreview(dataUri) {
    setOpenCam(false);
    onClose(dataUri);
  }

  const handleKapat = () => {
    setDataUri("");
    setOpenCam(false);
    onClose();
  }

  // Stop camera when modal closes
  useEffect(() => {
    if (!open) {
      setDataUri("");
      setOpenCam(false);
    }
  }, [open]);

  if (!open) {
    return null;
  }

  // YENİ: Kamera hatalarını yakalayan ve sessizce raporlayan fonksiyon
  function handleCameraError(error) {
    let mesaj = "Kamera başlatılamadı. Lütfen kontrol ediniz.";

    if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
      mesaj = "Kamera izniniz bulunmuyor. Lütfen tarayıcı ayarlarından izin verip sayfayı yenileyiniz!";
    }
    else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
      mesaj = "Kamera şu an başka bir uygulama (WhatsApp, Zoom vb.) tarafından kullanılıyor olabilir. Lütfen diğer uygulamaları kapatıp tekrar deneyiniz.";
    }

    // 2. Kullanıcıya bildir
    alert(mesaj);
  }

  const isFullscreen = false;
  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <form>
          <CardContent>
            {
              (openCam)
                ? <ImagePreview dataUri={dataUriUrl}
                  FisNo={FisNo}
                  DosyaTipi={DosyaTipi}
                  DosyaTipiText={DosyaTipiText}
                  onClose={onClosePreview}
                  isFullscreen={isFullscreen}
                  issondaj={issondaj}
                />
                :
                <Camera
                  onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
                  showFocus={true}
                  isImageMirror={false}
                  onCameraError={handleCameraError}
                  // isMaxResolution={true}
                  // imageCompression={0}
                  idealFacingMode={FACING_MODES.ENVIRONMENT}
                />
            }
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={handleKapat}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

CamPopupModel.propTypes = {
  className: PropTypes.string,
  DosyaTipi: PropTypes.string,
  DosyaTipiText: PropTypes.string,
  FisNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

CamPopupModel.defaultProps = {
  open: false,
  onClose: () => { }
};

export default CamPopupModel;
